import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { User as action } from '../../redux/actions';

/**
 * Returns all users of the account
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const users = (properties) => {
  const props = assign(properties);
  const model = {
    Users: props.data.users || [],
  };

  fetch(endpoint('/users'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          if (model.Users.length) {
            props.dispatch(action.create(response.Data));
          } else {
            props.dispatch(action.override(response.Data));
          }
        }
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default users;
